import { render } from "./EventFilter.vue?vue&type=template&id=15b4c678"
import script from "./EventFilter.vue?vue&type=script&lang=js"
export * from "./EventFilter.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__